import { Box, CircularProgress, Typography } from "@mui/material";
import React from "react";
import { useIntl } from "react-intl";

export interface CircleProgressIndicatorProps {
  value?: number;
}

export const CircleProgressIndicator: React.FC<
  CircleProgressIndicatorProps
> = ({ value = 0 }) => {
  const currentValue = value || 0;
  const { formatMessage } = useIntl();

  const ariaLabelSuffix = formatMessage({
    id: "circleProgressIndicator.ariaLabel",
  });
  const ariaLabelValue = `${currentValue} ${ariaLabelSuffix}`;

  return (
    <Box
      aria-label={ariaLabelValue}
      sx={{ position: "relative", display: "inline-flex" }}
    >
      <CircularProgress
        color="secondary"
        variant="determinate"
        value={100}
        sx={{
          position: "absolute",
        }}
        aria-hidden="true"
      />
      <CircularProgress
        variant="determinate"
        value={currentValue}
        aria-hidden="true"
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="caption"
          component="div"
          color="text.primary"
        >{`${Math.round(currentValue)}%`}</Typography>
      </Box>
    </Box>
  );
};
